import styled from "styled-components";

export const Container = styled.div`
	display: grid;
	grid-template-columns: 85px 1fr;
	column-gap: 10px;
	margin-top: 25px;
`;
